import { fromJS, Map } from 'immutable';

export function request(state, { id, legs }) {
    let settlements = state.get('settlements') || Map();

    settlements = settlements.set(id, Map({
        state: 'IN_PROGRESS',
        legs
    }));

    return state.set('settlements', settlements);
}

export function error(state, { id, errors }) {
    let settlements = state.get('settlements') || Map();

    settlements = settlements.set(id, Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state.set('settlements', settlements);
}

export function finish(state, { id, data }) {
    let settlements = state.get('settlements') || Map();

    settlements = settlements.set(id, Map({
        state: 'FINISHED'
    }));

    let items = state.get('items') || Map();
    items = items.set(id, fromJS(data));

    return state
        .set('items', items)
        .set('settlements', settlements);
}
